<template>
    <section class="notification-item">
        <section class="notification-item__icon">
            <img src="@/assets/icons/components/tooltip.svg" style="width: 24px;" />
        </section>
        <section class="notification-item__body">
            <section class="notification-item__body__title">
                {{$t('com.file.change-in-app-history.actualization')}}
            </section>
            <section class="notification-item__body__description">
                {{$t('com.file.change-in-app-history.check-actualization-info')}}
            </section>
            <section class="notification-item--center">
                <button class="notification-item__button notification-item__button--small notification-item__button--white"
                        @click="goToHistoryPage()">
                    <span class="notification-item__button__text">{{$t('com.file.change-in-app-history.click-to-see-more')}}</span>
                </button>
            </section>
        </section>
    </section>
</template>
<script charset="utf-8">
    export default {
        name: "ChangeInAppHistory",
        methods: {
            goToHistoryPage() {
                this.$router.push({ name: 'versions-history' });
            },
        }
    }
</script>
<style lang="scss" scoped>
    @use '@/assets/scss/notification-item.scss';
</style>